// extracted by mini-css-extract-plugin
module.exports = {"vRed":"#e3301b","vInkLightest":"#999","wrapper":"Empty__wrapper___YT9cb","subdued":"Empty__subdued___g4Gdc","error":"Empty__error___FtYAG","icon":"Empty__icon___rEWyw"};